// extracted by mini-css-extract-plugin
module.exports = {"root":"TimeRange_root__G5Tcm","bookingInfo":"TimeRange_bookingInfo__kRd_N","dateSection":"TimeRange_dateSection__56H7T"};